// This is a standard Angular 2+ component for demo purpose. It nests picture-ng2 as a child component

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  template: `
    <div class="ng2">
      <h1 class="ng2">About</h1>
    </div>
  `,
})
export class AboutNg2Component implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
